import { FC, useCallback, useEffect, ReactNode } from "react";
import { createPortal } from "react-dom";
import S from "./index.module.scss";

interface IModalProps {
  children: ReactNode;
  onClose: () => void;
}

const Modal: FC<IModalProps> = ({ children, onClose }) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if ((event.target as HTMLElement).tagName?.toLowerCase() === "input") return;

      if (event.key === "Escape") {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return createPortal(
    <div className={S.modal} onClick={onClose}>
      <div className={S.content} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.getElementById("portal")!,
  );
};

export default Modal;
